import {Component, OnInit} from '@angular/core';
import {SpriteImageModule} from '../sprite-image/sprite-image.module';
import {User} from '../../models/user/user';
import {AccountService} from '../../services/account.service';
import {ConfigService} from '../../services/config.service';
import {SvgIconModule} from '../svg-icon/svg-icon.module';
import {LayoutService} from '../../services/layout.service';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {UserPatch} from '../../models/user/user-patch';
import {UserService} from '../../services/user.service';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'site-header-your-place-dashboard',
    templateUrl: './site-header-your-place-dashboard.component.html',
    standalone: true,
    imports: [
        SpriteImageModule,
        SvgIconModule,
        RouterLinkActive,
        RouterLink,
        CommonModule
    ]
})
export class SiteHeaderYourPlaceDashboardComponent implements OnInit {
    currentUser: User;
    webUrl: string;
    mainMenuOpen = false;
    userMenuOpen = false;
    profileImage: string;
    profileImageAlt: string;

    constructor(
        private accountService: AccountService,
        private configService: ConfigService,
        private layoutService: LayoutService,
        private router: Router,
        private userService: UserService) {
    }

    ngOnInit() {
        this.currentUser = this.accountService.getCurrentUser();
        this.webUrl = this.configService.webUrl;
        this.layoutService.watchPanelOpenState()
            .subscribe(open => {
                this.mainMenuOpen = open;
            });
        this.accountService.watchCurrentUser()
            .subscribe(user => {
                this.currentUser = user;
                if (user && user.person) {
                    this.profileImage = user.person.image.thumbnail;
                    this.profileImageAlt = `${ user.person.forename } ${ user.person.surname }`;
                } else {
                    this.profileImage = null;
                    this.profileImageAlt = null;
                }
            });
    }

    closeMainMenu() {
        this.mainMenuOpen = false;
    }

    logout() {
        this.accountService.logout();
        const loginUrl = this.router.createUrlTree(['/login']);
        window.location.href = loginUrl.toString();
    }

    toggleUserMenu(open?: boolean) {
        if (open === false) {
            this.userMenuOpen = false;
        } else if (open === true) {
            this.userMenuOpen = true;
        } else {
            if (this.userMenuOpen) {
                setTimeout(() => this.userMenuOpen = false);
            } else {
                setTimeout(() => this.userMenuOpen = true);
            }
        }
    }

    toggleMainMenu() {
        if (this.mainMenuOpen) {
            const mainMenu = document.getElementById('MainMenu') as HTMLElement;
            if (mainMenu && mainMenu.classList.contains('open')) {
                mainMenu.classList.remove('open');
            }
            this.mainMenuOpen = false;
        } else {
            const mainMenu = document.getElementById('MainMenu') as HTMLElement;
            if (mainMenu && !mainMenu.classList.contains('open')) {
                mainMenu.classList.add('open');
            }
            this.mainMenuOpen = true;
        }
    }

    toggleDarkMode(darkModeOn: boolean) {
        const model = new UserPatch();
        model.darkMode = darkModeOn;
        this.userService.patchUser(model).subscribe();
    }
}
